import React from 'react';
import '../styles/SupportUs.css'; // Separate CSS file for styling

const SupportUs = () => {
  return (
    <div className="support-container">
      <p>
      Found this useful for your PTE preparation?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://buymeacoffee.com/learningtutorial" target="_blank" rel="noopener noreferrer">Support us with a coffee! ☕</a>
      </p>
    </div>
  );
};

export default SupportUs;
